// extracted by mini-css-extract-plugin
export default {"deactivateSettings":"deactivateSettings_deactivateSettings__9tYFh","show":"deactivateSettings_show__jpohD"};